module.exports = __webpack_public_path__ + "img/ITALY.3c28e98d.jpg";